export function slugify(text) {
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^\w\-]+/g, "")
        .replace(/\-\-+/g, "-")
        .replace(/^-+/, "")
        .replace(/-+$/, "");
}



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/utils/slugify.tsx
// module id = 03nD
// module chunks = 3